(function () {
    'use strict';
    /**
     * @memberof appback
     *@ngdoc service
     *@name ContactService
     *@description
     *Servicio de autores
     */

    angular
        .module('appback')
        .factory('ContactService', ContactService);

    ContactService.$inject = ["$http", "$q"];

    function ContactService($http, $q) {

        var contact = {
            GetContact: GetContact,
            GetRelacionados: GetRelacionados,
            GetConversaciones: GetConversaciones,
            GetMensajes: GetMensajes,
            Responder: Responder,
            CanalesDisponibles: CanalesDisponibles,
            IniciarConversacion: IniciarConversacion,
        };

        function GetContact(id) {
            return $http.get('/backend/contacto/getcontact', {
                params: {
                    id: id
                },
                headers: {}
            }).then(function (response) {
                if (!response.data || !response.data.success || !response.data.data) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            });
        }

        function GetRelacionados(id, tipo) {
            return $http.get('/backend/contacto/getrelacionados', {
                params: {
                    id: id,
                    tipo: tipo
                }
            }).then(function (response) {
                if (!response.data || !response.data.success) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            });
        }

        function GetConversaciones(id) {
            return $http.get('/backend/contacto/getconversaciones', {
                params: {
                    id: id
                }
            }).then(function (response) {
                if (!response.data || !response.data.success) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            });
        }

        function GetMensajes(id, conversacionId) {
            return $http.get('/backend/contacto/getmensajes', {
                params: {
                    id: id,
                    conversacionId: conversacionId
                }
            }).then(function (response) {
                if (!response.data || !response.data.success) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            });
        }

        function Responder(mensajeId, reply, note) {
            return postForm('/backend/contacto/responder', {
                id: mensajeId,
                reply: reply,
                note: note || ''
            }).then(function (response) {
                if (!response.data || !response.data.success) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            });
        }

        function CanalesDisponibles(id) {
            return $http.get('/backend/contacto/canalesdisponibles', {
                params: {
                    id: id
                }
            }).then(function (response) {
                if (!response.data || !response.data.success) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            });
        }

        function IniciarConversacion(id, channelUserId, mensaje, titulo) {
            return postForm('/backend/contacto/iniciarconversacion', {
                id: id,
                channelUserId: channelUserId,
                mensaje: mensaje,
                titulo: titulo || ''
            }).then(function (response) {
                if (!response.data || !response.data.success) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            });
        }

        function postForm(url, data) {
            return $http.post(url, jQuery.param(data), {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            });
        }

        return contact;
    }
})();

